<template>
  <div>
    <div class="contentTitle row">
      <p>購入には会員登録またはログインが必要です</p>
    </div>
    <div class="row editTab">
      <div class="editTab__content">
        <div
          class="editTab__item"
          v-for="item in tab.collection"
          :key="item.name"
          :data-active="item.name === tab.selected"
          @click="handleTabClick(item)"
        >
          <span>{{ item.text }}</span>
        </div>
      </div>
    </div>
    <form
      v-if="tab.selected === 'registerView'"
      :action="action"
      :method="method"
      @submit.prevent="handleSubmit()"
      ref="entryForm"
    >
      <input type="hidden" name="_token" :value="csrfToken">
      <input type="hidden" name="items_id" :value="itemsId">
      <input type="hidden" v-if="cpno" name="cpno" :value="cpno">
      <input type="hidden" v-if="categoryId" name="category_id" :value="categoryId">
      <input type="hidden" v-if="itemScheduleId" name="item_schedule_id" :value="itemScheduleId">
      <input type="hidden" v-if="guestId" name="guestId" :value="guestId">
      <input type="hidden" name="entry_detail_required" :value="entryDetailRequired">
      <input type="hidden" v-if="orderGenre" name="order_genre" :value="orderGenre">

      <!-- 会員登録情報 -->
      <section class="enteyForm" v-if="!isLoggedIn">
        <!-- <h1 class="entryForm__heading"><strong>会員登録情報</strong></h1> -->
        <div v-for="(field, key) in auth" :key="key" class="u-mg-b-3">
          <entry-form-input v-model="auth[key].value" :name="key" :field="field"></entry-form-input>
          <p v-if="key=='email'" class="formGroup__subText">※携帯メールアドレスをお使いの場合
            <br>ドメイン設定の影響で登録メールが届かない場合がありますので、事前に「uranai.tv」を
            <a href="/help#2">受信設定</a>することをオススメしております。
          </p>
          <p
            v-if="key=='password'"
            class="formGroup__subText"
          >半角の英数大文字、英数小文字、数字を組み合わせて8文字以上30文字以内にしてください。</p>
        </div>

        <!-- 利用規約チェックボックス -->
        <label class="confirmTerms">
          <input
            type="checkbox"
            class="confirmTerms__checkbox"
            name="accept_terms"
            value="1"
            v-validate="'required'"
          >
          <span class="confirmTerms__label">
            <a href="https://agaru.tv/terms-of-service/" target="_new">利用規約</a>と
            <a href="https://agaru.tv/privacy/" target="_new">プライバシーポリシー</a>に同意する
          </span>
        </label>
        <p v-show="errors.has('accept_terms')" class="formGroup__errorMessage">利用規約へ同意して頂く必要があります。</p>
      </section>

      <section class="entryForm" v-if="itemsId == '000801'">
        <div class="entryForm">
          <label class="formLabel">
            <span class="labelBadge--required">必須</span>鑑定を希望する占い師名
          </label>
          <form-select v-model="selectCounselor" name="free_text" :options="counselors"></form-select>
          <p class="formGroup__subText">※応募状況によっては希望された占い師以外のビデオレターが当選する場合もございます。予めご了承ください。</p>
        </div>
      </section>

      <!-- 自分プロフィール -->
      <section class="entryForm" v-show="showFieldSection(self)">
        <div v-for="(field, key) in self" :key="key" class="u-mg-b-3">
          <entry-form-input
            v-model="self[key].value"
            :name="key"
            :field="field"
            :is-edit-mode="isEditMode"
          ></entry-form-input>
        </div>
      </section>

      <!-- 手相 -->
      <section class="entryForm" v-show="showFieldSection(palm)">
        <div v-for="(field, key) in palm" :key="key" class="u-mg-b-3">
          <entry-form-input
            v-model="palm[key].value"
            :name="key"
            :field="field"
            :is-edit-mode="isEditMode"
          ></entry-form-input>
        </div>
      </section>

      <!-- 相手プロフィール -->
      <section class="entryForm" v-show="showFieldSection(target)">
        <div v-for="(field, key) in target" :key="key" class="u-mg-b-3">
          <entry-form-input
            v-model="target[key].value"
            :name="key"
            :field="field"
            :is-edit-mode="isEditMode"
          ></entry-form-input>
        </div>
      </section>

      <!-- 相談内容 -->
      <section class="entryForm" v-if="!isRandSelect" v-show="showFieldSection(entry)">
        <div class="u-mg-b-3" v-if="categoryId==6">
          <form-label label="テーマ"></form-label>
          <p class="u-mg-t-0">
            <strong class="u-tx-brand">{{orderGenre}}</strong>
          </p>
        </div>
        <div v-for="(field, key) in entry" :key="key" class="u-mg-b-3">
          <entry-form-input
            v-model="entry[key].value"
            :name="key"
            :field="field"
            :is-edit-mode="isEditMode"
            :entry-detail-required="entryDetailRequired"
            @input="handleChangeEntryInput(key, field)"
          >
            <template v-if="!isRandSelect" slot="aside" v-html="field.subtext"></template>
            <template v-else slot="aside" v-html="expText"></template>
          </entry-form-input>
        </div>
      </section>

      <section class="entryFormFooter">
        <button class="btn" data-block="true" data-color="brand">入力した内容を確認</button>
      </section>
    </form>

    <div v-else-if="tab.selected === 'loginView'">
      <!-- <h1 class="entryForm__heading">
      <strong>ログインしてください</strong><br>購入手続きにはログインが必要です
      </h1>-->
      <login-form action="/user/login" :reissueKey="reissueKey"></login-form>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import * as type from '@/utvStore/store/mutation-types';
import EntryFormInput from './EntryFormInput';
import dataControl from './mixins/dataControl';
import viewControl from './mixins/viewControl';
import formControl from './mixins/formControl';

export default {
  name: 'guest-entry-form',
  props: {
    isRandSelect: Boolean,
    expText: String
  },
  mixins: [dataControl, viewControl, formControl],
  components: {
    EntryFormInput
  },
  beforeMount() {
    this.initializeInputData();
    this.tab.selected = document.cookie.includes('amuu=') ? 'loginView' : 'registerView';
  },
  mounted() {
    this.deleteUnuseColumn();
    this.setEntryQuestions(this.categoryId, this.inputEntryType);
  },

  data: () => ({
    cpno: window.Laravel.cpno,
    csrfToken: window.Laravel.csrfToken,
    tab: {
      selected: 'loginView',
      collection: [
        {
          name: 'registerView',
          text: '会員登録して購入'
        },
        {
          name: 'loginView',
          text: '登録済みの方'
        }
      ]
    },
    selectCounselor: '',
    counselors: [
      { text: '希望なし', value: '希望なし' },
      { text: 'Hoshi (not for sale.)', value: 'Hoshi (not for sale.)' },
      { text: '生田目浩美.', value: '生田目浩美.' },
      { text: '青沼李果', value: '青沼李果' },
      { text: '巫弥子', value: '巫弥子' },
      { text: '海龍', value: '海龍' },
      { text: '阿雅佐', value: '阿雅佐' },
      { text: '安沙蘭', value: '安沙蘭' },
      { text: 'ミルン', value: 'ミルン' },
      { text: '法演', value: '法演' },
      { text: 'カフナ・ハウ・ユカ', value: 'カフナ・ハウ・ユカ' },
      { text: 'R.I.O.N', value: 'R.I.O.N' },
      { text: '藤元麻理', value: '藤元麻理' }
    ],
    isEditMode: false
  }),

  methods: {
    // バリデーション処理
    validateBeforeSubmit() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll().then(result => {
          if (!result) {
            // エラーがある要素までスクロール
            if (this.errors.items[0]) {
              let target = `[data-vv-id="${this.errors.items[0].id}"]`;
              let position = $(target).offset().top;
              $('html, body').animate(
                {
                  scrollTop: position - 88
                },
                250
              );
            }
            return reject();
          }
          return resolve();
        });
      });
    },
    // Submit処理
    handleSubmit() {
      this.validateBeforeSubmit()
        .then(() => {
          this.$refs.entryForm.submit();
        })
        .catch(() => {
          return false;
        });
    }
  }
};</script>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/EntryForm/GuestEntryForm.vue